import { render, staticRenderFns } from "./VehUsgs.vue?vue&type=template&id=9b661172&"
import script from "./VehUsgs.vue?vue&type=script&lang=js&"
export * from "./VehUsgs.vue?vue&type=script&lang=js&"
import style0 from "./VehUsgs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VehUsgs.vue"
export default component.exports